// import { optionSelectAll } from "@/utils/commonUtils";

const danhSachNhomChucVu = state => state.danhSachNhomChucVu;
const danhSachNhomChucVuPaging = state => state.danhSachNhomChucVuPaging;

export default {
  danhSachNhomChucVu,
  danhSachNhomChucVuPaging
};
